var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.instance)?_c('v-alert',{staticClass:"mx-3",attrs:{"icon":_vm.icon,"outlined":_vm.outlined,"type":_vm.color,"text":""}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }